// extracted by mini-css-extract-plugin
export default {"DoctorCard":"DoctorChoice_DoctorCard__VEgeF","SearchButton":"DoctorChoice_SearchButton__mmrkE","NoResult":"DoctorChoice_NoResult__SlTy6"};